import { DownloadCta } from '../components/DownloadCta';
import { LimitsSection } from '../components/LimitsSection';
import { PrivacySection } from '../components/PrivacySection';
import { useI18n } from '../i18n/useI18n';
import { useSeo } from './useSeo';

export function PrivacyPage() {
  const { t } = useI18n();
  useSeo('seo.privacy.title', 'seo.privacy.description');

  return (
    <main>
      <section className="page-hero">
        <p className="eyebrow">{t('privacy.eyebrow')}</p>
        <h1>{t('privacy.pageTitle')}</h1>
        <p>{t('privacy.pageText')}</p>
      </section>
      <PrivacySection />
      <LimitsSection />
      <DownloadCta />
    </main>
  );
}
